export default __webpack_public_path__ + "static/media/payment_icon_2.1e4cdc2e.svg";